"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class InvalidLastKeyParameter extends client_library_1.ExtendableError {
    constructor() {
        super(`Invalid lastKey parameter provided`);
    }
}
exports.default = InvalidLastKeyParameter;
//# sourceMappingURL=InvalidLastKeyParameter.js.map